import React from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import useAutocompleteDropdownStyles from './styles'

const AutocompleteDropdown = ({
  label,
  value,
  onChange,
  options,
  error,
  helperText,
  placeholder,
}) => {
  const classes = useAutocompleteDropdownStyles()

  return (
    <div className={classes.root}>
      <Autocomplete
        freeSolo
        value={value || ''}
        onChange={(event, newValue) => {
          // Call onChange with the selected or typed value
          onChange({ target: { value: newValue || '' } })
        }}
        onInputChange={(event, newInputValue) => {
          // Handle manual typing
          if (event?.type === 'change') {
            onChange({ target: { value: newInputValue } })
          }
        }}
        options={options || []}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            error={error}
            helperText={helperText}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '50px',
                backgroundColor: '#fff',
                boxShadow: '4px 4px 15px rgba(0, 0, 0, 0.05)',
              },
            }}
          />
        )}
      />
    </div>
  )
}

AutocompleteDropdown.propTypes = {}

export default AutocompleteDropdown
